import { Router } from 'next/router';
import React, { useEffect, useState, useContext } from 'react';

const HistoryContext = React.createContext<
  | {
      prevUrl: string;
    }
  | undefined
>(undefined);

export interface HistoryProviderProps {
  children: React.ReactNode;
}

export const HistoryProvider = ({ children }: HistoryProviderProps) => {
  const [prevUrl, setPrevUrl] = useState('');

  useEffect(() => {
    const handleRouteChange = () => {
      setPrevUrl(window.location.href);
    };

    Router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      Router.events.off('routeChangeStart', handleRouteChange);
    };
  }, []);

  return (
    <HistoryContext.Provider value={{ prevUrl }}>
      {children}
    </HistoryContext.Provider>
  );
};

export function usePrevUrl(): string {
  const context = useContext(HistoryContext);
  if (!context) {
    throw new Error(
      'usePrevUrl must be inside a HistoryContext with a state value',
    );
  }
  return context.prevUrl;
}
